module.exports = __webpack_public_path__ + "media/images/captive_portal/Color-Five-737531cc3982731723dbcf74b36d3fd9.png";